import * as React from "react";
import {Link} from "react-router-dom";
import {getInsurerNameFromBrandId} from "@ferry/portal-core"

interface IProps {
    product: string,
    policyNumber: string,
    brandName: string
}

export class DirectDebitInformationModal extends React.Component<IProps> {

    public render(): React.ReactNode {
        const faqUrl: string = `/dashboard/help/${this.props.policyNumber}`;

        return (
                <div className="inner-content mb-3 p-0">
                    <p>
                    <span className="font-weight-bold">
                        Please note that changes to your Direct Debit details can take up to 10 working days to take effect. </span>
                        That means if your next instalment date falls in this window, there's a small chance we'll miss
                        it.
                        If this happens you will have to pay the instalment by card.</p>
                    <p>
                        You must pay from your own current account (not a savings or business account).
                        Your payments will be collected under <span
                        className="font-weight-bold">{getInsurerNameFromBrandId(this.props.brandName)} Insurance</span> name.
                    </p>
                    <p>
                        Need help?{' '}
                        <Link className="d-inline font-weight-bold text-decoration-underline" target="_blank" to={faqUrl}>Our FAQs</Link>{' '}
                        have the answers for Direct Debit queries.
                    </p>
                </div>
        );
    }

}
